import { getLocale } from '../../../i18n';

export function dateTime(iso: string): string {
  return new Intl.DateTimeFormat(getLocale(), { dateStyle: 'short', timeStyle: 'short' }).format(
    new Date(iso),
  );
}

const CALENDAR_DATE = /^\d{4}-\d{2}-\d{2}$/;

/** A bare date names a calendar day, not an instant: read in the reader's zone
 *  it would land on the previous evening. */
export function dayMonth(iso: string): string {
  return new Intl.DateTimeFormat(getLocale(), {
    day: '2-digit',
    month: '2-digit',
    timeZone: CALENDAR_DATE.test(iso) ? 'UTC' : undefined,
  }).format(new Date(iso));
}

export function initials(name: string): string {
  return name
    .replace(/^@/, '')
    .split(/\s+/)
    .filter((part) => part !== '')
    .slice(0, 2)
    .map((part) => part.charAt(0).toUpperCase())
    .join('');
}

/** The caption's first line as the heading, the rest — if any — as the
 *  excerpt. A blank caption reads the same as a null one. */
export function splitCaption(caption: string | null): {
  heading: string | null;
  excerpt: string | null;
} {
  const trimmed = caption?.trim() ?? '';
  if (trimmed === '') return { heading: null, excerpt: null };
  const newline = trimmed.indexOf('\n');
  if (newline === -1) return { heading: trimmed, excerpt: null };
  const excerpt = trimmed.slice(newline + 1).trim();
  return { heading: trimmed.slice(0, newline).trim(), excerpt: excerpt === '' ? null : excerpt };
}

/** A network- or content-kind token the frontend owns no vocabulary for:
 *  title-cased rather than shown as the wire's raw word. */
export function humanize(raw: string): string {
  return raw
    .replace(/[_-]+/g, ' ')
    .trim()
    .replace(/\b\w/g, (char) => char.toUpperCase());
}
